module.exports = __webpack_public_path__ + "img/Canada.94914edc.svg";